<template>
  <base-slide-panel 
    class="z-chatbot-dialog"
    :isOpen="panelOpen" 
    :footer="false"
    :autoHeight="true"
    :onlyInvisible="true"
    @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="chatbot"/>
          <h2 class="font-bold ml-2">{{$t('ia.title')}}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="bg-primary-50 w-full h-full dark:bg-darkblue-800 dark:text-darkblue-200">
        <AIChatComponent/>
      </div>
    </template>
  </base-slide-panel>
</template>

<script>
import AIChatComponent from '@/components/ia/AIChatComponent.vue'

export default {
  name: 'chat-panel',
  components: {
    AIChatComponent,
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isOpen: this.panelOpen
    }
  },
  methods: {
    togglePanel: function () {
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>

